angular.module('vastdesk').
  component('directConnectionDspForm',  {
    bindings: {
      formName: '@',
      formId: '@',
      showAction: '<',
      establishedConnection: '<',
      requestedStatusChange: '@',
      status: '@',
      connectionsClear: '<',
      paymentTerms: '@',
      receivableTerms: '@',
      netPayableTerm: '<',
      netReceivableTerm: '<',
      tilesConnectionsClear: '<',
      tilesPaymentTerms: '@',
      tilesReceivableTerms: '@',
      tilesNetPayableTerm: '<',
      tilesNetReceivableTerm: '<',
      otherAccountName: '@',
      accountContactName: '@',
      accountContactEmail: '@',
      accountContactOptions: '<',
      accountContactId: '@',
      message: '@',
      availableStatusChangeOptions: '<',
      directConnectionStatusMappings: '<',
      connectionsClearInfo: '@',
      tilesConnectionsClearInfo: '@',
      clearingFilterOptions: '<'
    },
    template: require("../templates/directConnectionDspForm.html"),
    controllerAs: '$directConnectionDspFormCtrl',
    controller: function() {

      var self = this;

      this.setRequestedStatusChange = function(requestedStatus) {
        self.requestedStatusChange = requestedStatus;
      };

      this.unchangedStatus = function() {
        return self.status === self.requestedStatusChange;
      };

      this.statusChangedFromTo = function(from, to) {
        return self.status === from && self.requestedStatusChange === to;
      };

      this.statusChangedTo = function(to) {
        return self.status !== to && self.requestedStatusChange === to;
      };

      this.showCrudFields = function() {
        return self.status === 'pending_approval' || self.status === 'unconnected';
      };

      this.showReadOnlyFields = function() {
        return self.status !== 'pending_approval' && self.status !== 'unconnected';
      };

      this.actionPending = function() {
        return self.statusChangedTo('connected');
      };

      var urlWithoutQueryString = function(href) {
        var split = href.split('?');

        if (split.length > 1) {
          href = split[0] + window.location.hash;
        }

        return href;
      };

      var resetHistory = function() {
        var href = window.location.href;

        if (/requested_status_change=/.test(href)) {
          window.history.replaceState({}, document.title, urlWithoutQueryString(href));
        }
      };

      resetHistory();

    }
});
